import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex",
  style: {"column-gap":"12px"}
}
const _hoisted_2 = {
  style: {"flex-basis":"fit-content","flex-grow":"1","max-width":"100%"},
  class: "q-mt-md"
}
const _hoisted_3 = { class: "q-ma-none text-h3" }
const _hoisted_4 = {
  style: {"flex-grow":"1"},
  class: "q-mt-md"
}

import ProfileName from 'src/components/etc/ProfileName.vue';
import {PropType} from 'vue';
import {User} from 'src/models/user';
import {Business} from 'src/models/business.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileAvatarHeader',
  props: {
  avatarSrc: {
    type: String,
    default: undefined
  },
  owner: {
    type: Object as PropType<User | Business | undefined>,
    default: undefined
  },
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle([{"margin-top":"-5.5rem","z-index":"1","flex-shrink":"0"}, {'margin-left': !_ctx.$q.screen.lt.sm ? '2.5vw' : undefined}])
    }, [
      _createVNode(_component_q_img, {
        src: __props.owner?.avatar?.path,
        alt: "Profile image",
        class: "shadow-1 bg-grey-3",
        width: "8rem",
        height: "8rem",
        style: {"border-radius":"50%"},
        "no-spinner": ""
      }, null, 8, ["src"])
    ], 4),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([{'full-width': _ctx.$q.screen.lt.sm}, "column"])
      }, [
        _createVNode(ProfileName, {
          "disable-link": ['business-profile', 'profile'].includes(_ctx.$route.name),
          owner: __props.owner
        }, {
          name: _withCtx(({user}) => [
            _createElementVNode("h2", _hoisted_3, _toDisplayString(user.public_name ?? user.name), 1)
          ]),
          _: 1
        }, 8, ["disable-link", "owner"])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "buttons")
    ])
  ]))
}
}

})